import { Outlet } from 'react-router-dom'
import { BANK_VIEW_ROLES } from '@crm/shared'
import { useAuthStore } from '../auth/authStore'
import { EmptyState } from '../../shared/ui/EmptyState'

/**
 * Ворота раздела «Банк» (этап 3, Б2, docs/features/client-payments.md): бухгалтер
 * и администратор работают, генеральный директор смотрит. Остальным — заглушка
 * без запросов к API. Раздел живёт вне `CrmRoleGate`: бухгалтер — роль этапа 3.
 */
export function BankRouteGate() {
  const role = useAuthStore((s) => s.user?.role)
  if (!role || !(BANK_VIEW_ROLES as string[]).includes(role)) {
    return (
      <div className="p-6">
        <EmptyState
          title="Раздел недоступен"
          description="Раздел «Банк» ведёт бухгалтерия; его видят также администратор и генеральный директор."
        />
      </div>
    )
  }
  return <Outlet />
}
